<input
  #input
  matInput
  [formlyAttributes]="field"
  [type]="hidden ? 'password' : 'text'"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [(ngModel)]="value"
  [ngClass]="field.templateOptions.class"
  (focus)="onFocusChanged(true)"
  (blur)="onFocusChanged(false)"
/>

<sn-icon-button
  *ngIf="toggleMask"
  matSuffix
  class="password-icon"
  tabindex="-1"
  (click)="toggleVisibility()"
  [disabled]="disabled"
>
  <sn-icon>{{ hidden ? 'visibility' : 'visibility_off' }}</sn-icon>
</sn-icon-button>
